import ContentBlockDescription from '@/components/custom/ContentBlock/ContentBlockDescription/index.vue';
import IconPlay from '@/components/icons/IconPlay.vue';
import { mapMutations } from 'vuex';
import { getVideoConfig, VIDEO_TYPE } from '@/helpers';

export default {
  name: 'ContentBlockModalVideo',
  components: { IconPlay, ContentBlockDescription },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isPlaying: false,
      isYouTubeLink: false,
      videoUrl: null,
      videoType: VIDEO_TYPE.DEFAULT,
      videoPreview: null
    };
  },
  created() {
    let { type, preview } = getVideoConfig(this.data.video, this.data.image);
    this.videoType = type;
    this.videoPreview = preview;
  },
  mounted() {},
  computed: {},
  methods: {
    ...mapMutations({
      modalOpen: 'app/MODAL_OPEN',
      modalSetData: 'app/MODAL_SET_DATA'
    }),
    onHandleVideoPlay() {
      this.modalSetData({ key: 'youtubeVideo', data: { link: this.data.video, type: this.videoType } });
      this.modalOpen('youtubeVideo');
    }
  }
};
